import { useState, useEffect } from 'react';
export function usePrefersReducedMotion(options) {
    if (options === void 0) { options = {}; }
    var _a = options.ssr, ssr = _a === void 0 ? false : _a;
    var _b = useState(ssr), prefersReducedMotion = _b[0], setPrefersReducedMotion = _b[1];
    useEffect(function () {
        if (!window.matchMedia) {
            setPrefersReducedMotion(false);
            return;
        }
        var mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        setPrefersReducedMotion(mediaQuery.matches);
        function onChange(event) {
            setPrefersReducedMotion(event.matches);
        }
        mediaQuery.addEventListener('change', onChange);
        return function () {
            mediaQuery.removeEventListener('change', onChange);
        };
    }, []);
    return prefersReducedMotion;
}
//# sourceMappingURL=usePrefersReducedMotion.js.map